import React from 'react';
import styled from 'styled-components';
import { logo } from "../../Shared/config";


const Footer = () => {
    return (
        <FooterContainer>
            <img
                src={logo}
                alt="v3logo"
                style={{
                    width: '30px',
                    height: '30px',
                    marginLeft: '2px'
                }} />
        </FooterContainer>
    );
};

export default Footer;

const FooterContainer = styled.div`
  display: flex;
  opacity: 0.7;
  justify-content: center;
  align-items: center;
  height: 40px;
 color: '#4a4a4a';
  font-size: 14px;
`;



// import React from 'react';
// import styled from 'styled-components';
// import { logo } from "../../Shared/config";


// const Footer = () => {
//     return (
//         <Logo>
//             <img src={logo} alt="logo" />
//         </Logo>
//     );
// };

// export default Footer;

// const Logo = styled.div`
//   width: 20%;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   img {
//     width: 30%;
//     height: 100%;
//     object-fit: contain;
//   }
// `;